// Workspace slug helpers (pure, tested in test/slug.test.ts).

const COMBINING_MARKS = /[̀-ͯ]/g;

/** Turn an arbitrary name into a URL-safe workspace slug. */
export function slugify(input: string): string {
  return input
    .toLowerCase()
    .normalize("NFKD")
    .replace(COMBINING_MARKS, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 48)
    .replace(/-+$/g, "");
}

const SLUG_RE = /^[a-z0-9][a-z0-9-]*$/;

export function isValidSlug(slug: string): boolean {
  return slug.length >= 1 && slug.length <= 48 && SLUG_RE.test(slug) && !slug.endsWith("-");
}
